export default {
    topics: [
        {
            title: ' BuildAndInstallSchemas ',
            href: 'sm-sqlSchema-BuildAndInstallSchemas.html',
            attributes: { 'data-id': 'sm-sqlSchema-BuildAndInstallSchemas' },
            menu: { hasChildren: false },
            tocID: 'sm-sqlSchema-BuildAndInstallSchemas-d66e1689',
            topics: [],
        },
        {
            title: ' BuildSqlSchema ',
            href: 'sm-sqlSchema-BuildSqlSchema.html',
            attributes: { 'data-id': 'sm-sqlSchema-BuildSqlSchema' },
            menu: { hasChildren: false },
            tocID: 'sm-sqlSchema-BuildSqlSchema-d66e1697',
            topics: [],
        },
        {
            title: ' BuildTableList ',
            href: 'sm-sqlSchema-BuildTableList.html',
            attributes: { 'data-id': 'sm-sqlSchema-BuildTableList' },
            menu: { hasChildren: false },
            tocID: 'sm-sqlSchema-BuildTableList-d66e1705',
            topics: [],
        },
        {
            title: ' Generate ',
            href: 'sm-sqlSchema-Generate.html',
            attributes: { 'data-id': 'sm-sqlSchema-Generate' },
            menu: { hasChildren: false },
            tocID: 'sm-sqlSchema-Generate-d66e1713',
            topics: [],
        },
        {
            title: ' PatchSrcSchemas ',
            href: 'sm-sqlSchema-PatchSrcSchemas.html',
            attributes: { 'data-id': 'sm-sqlSchema-PatchSrcSchemas' },
            menu: { hasChildren: false },
            tocID: 'sm-sqlSchema-PatchSrcSchemas-d66e1721',
            topics: [],
        },
        {
            title: ' UpdateFieldProp ',
            href: 'sm-sqlSchema-UpdateFieldProp.html',
            attributes: { 'data-id': 'sm-sqlSchema-UpdateFieldProp' },
            menu: { hasChildren: false },
            tocID: 'sm-sqlSchema-UpdateFieldProp-d66e1729',
            topics: [],
        },
        {
            title: ' UpdateSchema ',
            href: 'sm-sqlSchema-UpdateSchema.html',
            attributes: { 'data-id': 'sm-sqlSchema-UpdateSchema' },
            menu: { hasChildren: false },
            tocID: 'sm-sqlSchema-UpdateSchema-d66e1737',
            topics: [],
        },
    ],
};

